
(()=>{if(window.BedaDesignLoaded)return;window.BedaDesignLoaded=true;let opener=null;
const openDialog=id=>{const d=document.getElementById(id);if(!d)return;document.querySelectorAll('.bp-dialog[open]').forEach(x=>x.close());opener=document.activeElement;d.showModal();if(id==='bp-search')setTimeout(()=>d.querySelector('input')?.focus(),30)};
document.addEventListener('click',e=>{const searchSummary=e.target.closest('.bp-menu-search-mobile > summary');if(searchSummary&&!searchSummary.parentElement.open){e.preventDefault();searchSummary.parentElement.open=true;searchSummary.parentElement.querySelector('input[type=search]')?.focus();return}const open=e.target.closest('[data-bp-open]');if(open){e.preventDefault();openDialog(open.dataset.bpOpen);return}const close=e.target.closest('[data-bp-close]');if(close){close.closest('dialog')?.close();return}if(e.target instanceof HTMLDialogElement&&e.target.classList.contains('bp-dialog')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close()}});
document.addEventListener('close',e=>{if(e.target.classList?.contains('bp-dialog'))opener?.focus?.()},true);
const size=()=>{const h=document.querySelector('.bp-header');if(h){document.body.style.setProperty('--header-height',h.offsetHeight+'px');document.body.style.setProperty('--header-group-height',h.offsetHeight+'px')}};
size();if(window.ResizeObserver){const h=document.querySelector('.bp-header');if(h)new ResizeObserver(size).observe(h)}document.addEventListener('shopify:section:load',size);
const cartUrl=()=>((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart.js';
const refreshCart=async()=>{try{const r=await window.__bpFetch(cartUrl(),{headers:{Accept:'application/json'}});if(!r.ok)return;const c=await r.json();document.querySelectorAll('.bp-bag-count').forEach(el=>el.textContent=String(c.item_count||0))}catch{}};
window.__bpFetch=window.fetch.bind(window);window.fetch=async(...args)=>{const response=await window.__bpFetch(...args);try{const u=typeof args[0]==='string'?args[0]:(args[0]&&args[0].url)||'';if(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(u))setTimeout(refreshCart,80)}catch{}return response};
['cart:update','cart:updated','cart:refresh','product:added'].forEach(n=>document.addEventListener(n,refreshCart));window.addEventListener('pageshow',refreshCart);
})();

(() => {
  const codePattern = /^(?:B-)?\d+(?:[-/_]\d+)*$/i;
  const normalize = value => value.trim().toUpperCase().replace(/^B\s*-?\s*(?=\d)/, 'B-');
  const codeQuery = value => {
    const code = normalize(value);
    if (!codePattern.test(code)) return value;
    const variants = [code, `BP_${code}`];
    if (/^\d+$/.test(code)) variants.push(`B-${code}`, `BP_B-${code}`);
    return variants.map(tag => `tag:"${tag}"`).join(' OR ');
  };
  const displayQuery = query => {
    const quoted = /^tag:"((?:B-)?\d+(?:[-/_]\d+)*)"/i.exec(query || '');
    const old = /^tag:BP_((?:B-)?\d+(?:[-/_]\d+)*)$/i.exec(query || '');
    return normalize(quoted?.[1] || old?.[1] || query || '');
  };
  const restoreProductCode = () => {
    const query = new URLSearchParams(window.location.search).get('q');
    if (!query || !/^tag:/i.test(query)) return;
    const display = displayQuery(query);
    document.title = document.title.replace(query, display);
    document.querySelectorAll('.search-results__no-results').forEach(message => {
      message.textContent = message.textContent.replace(query, display);
    });
    document.querySelectorAll('form[action*="/search"] input[name="q"]:not(#bp-search-input)').forEach(input => {
      input.value = display;
    });
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, window.location.origin).pathname.endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    input.value = codeQuery(input.value);
  }, true);
  restoreProductCode();
})();


